import {
  Component,
  Input,
  OnDestroy,
  Inject,
  ViewEncapsulation
} from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Store, select } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { AppState, selectMainMenuState } from '../core/core.state';

@Component({
  selector: 'app-spinner',
  template: `<div class="preloader" *ngIf="isSpinnerVisible">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
    </div>`,
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {
  public isSpinnerVisible = true;
  public navigationEnded = false;
  @Input() public backgroundColor = 'rgba(0, 115, 170, 0.69)';

  constructor(
    private router: Router,
    private store: Store<AppState>,
    @Inject(DOCUMENT) private document: Document
  ) {
    combineLatest([ this.router.events, this.store.select(selectMainMenuState) ])
    .subscribe(
      ([event, menuItems]) => {
        if (event instanceof NavigationStart) {
          this.isSpinnerVisible = true;
        } else if (
          (event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError)
        ) {
          this.navigationEnded = true;
        }
        if (this.navigationEnded && menuItems.menuLoaded) {
          this.isSpinnerVisible = false;
        }
      },
      () => {
        this.isSpinnerVisible = false;
      }
    );
  }

  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }
}
